export default __webpack_public_path__ + "static/media/movenpic-boracay-slider.2dccaf7e.jpg";